var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-pipeline",class:{ horizontal: _vm.horizontal }},[_c('div',{staticClass:"all-pipeline-container"},[(_vm.horizontal)?_c('div',{staticClass:"lists-container"},[_vm._t("lists")],2):_vm._e(),(_vm.horizontal)?_c('div',{staticClass:"cards-container",style:(_vm.height)},[_vm._t("cards")],2):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }